import React from 'react';
import PropTypes from 'prop-types';
import CwButton from '../cwbutton/CwButton';
import CwFlyout from '../cwflyout/CwFlyout';
import css from './CwFlyoutButton.scss';

class CwFlyoutButton extends React.Component {

  constructor() {
    super();
    this._ignoreBlur = false;
    this.state = {
      flyout: false,
      buttonY: 0,
      buttonX: 0,
    };
    this._buttonX = 0;
    this._buttonY = 0;
  }

  componentWillMount = () => {
    window.addEventListener('mousedown', this.handleOnBlur, false);
  };

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.handleOnBlur);
  };

  handleOnClick = () => {
    this.getButtonCenter();
    this.setState((prevState) => {
      return { flyout: !prevState.flyout };
    });

    if(this.props.onClick) {
      this.props.onClick();
    }
  };

  handleOnBlur = () => {
    if (this._ignoreBlur) {
      return;
    }
    if (this.state.flyout) {
      this.setState({ flyout: false });
      if (this.props.onBlur) {
        this.props.onBlur();
      }
    }
  };

  mouseDownHandler = () => {
    this._ignoreBlur = true;
  };

  mouseUpHandler = () => {
    this._ignoreBlur = false;
  };

  getButtonCenter = () => {
    const node = this.button.cwButton;
    const rect = node.getBoundingClientRect();
    this._buttonX = rect.left + ((rect.right - rect.left) / 2);
    this._buttonY = rect.top + ((rect.bottom - rect.top) / 2);

    this.setState({
      buttonX: node.offsetWidth / 2,
      buttonY: node.offsetHeight,
    });
  }

  disabled = () => {
    return (this.props.children === null || this.props.children.length < 1);
  };

  render() {

    return (
      <div data-cwid={this.props.cwId}
        onMouseDown={this.mouseDownHandler}
        onMouseUp={this.mouseUpHandler}
        className={css.wrap}>
        <CwButton
          disabled={this.props.disabled || this.disabled()}
          ref={(input) => this.button = input}
          icon={this.props.icon}
          onBlur={this.handleOnBlur}
          onFocus={this.props.onFocus}
          onClick={this.handleOnClick}
          value={this.props.value}
          rightIcon={this.props.rightIcon}
          height={this.props.buttonHeight}
          isStandard={this.props.buttonIsStandard}
          style={this.props.buttonStyle}
          isMenu
        />
        {this.state.flyout ?
          <CwFlyout
            ref={(input) => this.dialog = input}
            id={0}
            header={this.props.header ? this.props.header : this.props.value}
            x={this.state.buttonX}
            y={this.state.buttonY}
            xCoord={this._buttonX}
            yCoord={this._buttonY}>
            {this.props.children}
          </CwFlyout>
          : null}
      </div>
    );
  }
}

CwFlyoutButton.propTypes = {
  /**
   * Callback function that is fired when CwFlyoutButton is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when CwFlyoutButton is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Used to disable the button
   */
  disabled: PropTypes.bool,
  /**
   * Text to be shown in the button
   */
  value: PropTypes.string,
  /**
   * Content to be shown in the flyout
   */
  children: PropTypes.any,
  /**
   * Optional icon placed on left side of button
   */
  icon: PropTypes.string,
  /**
   * Path to a svg icon to be displayed on the right side of the button text
   */
  rightIcon: PropTypes.string,
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * The css class name to be appended to default classname
   */
  className: PropTypes.string,
  /**
   * Used to control button height
   */
  buttonHeight: PropTypes.number,
  /**
   * Used to control if the button is standard or light
   */
  buttonIsStandard: PropTypes.bool,
  /**
   * Override the styles of the root element
   */
  buttonStyle: PropTypes.object,
  /**
   * Used to control order when tabbing through items
   */
  tabIndex: PropTypes.number,
  /**
   * Optional header for the flyout if on specified the header defaults to the value prop
   */
  header: PropTypes.string,
  /**
   * Callback function fired when button is clicked
   */
  onClick: PropTypes.func,
};

export default CwFlyoutButton;


// WEBPACK FOOTER //
// ./src/components/cwflyoutbutton/CwFlyoutButton.jsx